<template>
  <div>
    <link href="https://cdnjs.cloudflare.com/ajax/libs/MaterialDesign-Webfont/5.8.55/css/materialdesignicons.min.css" rel="stylesheet">
    <div class="row parking-big-row main-container" style="z-index: 11; top: 0; position: absolute;" v-if="loggedIn && (isMessages || isContacts || isRecents || isSettings)">
      <div style="width: 100%; padding: 0 15px;">
        <div class="row">
          <div class="col-12" style="padding: 0;">
            <Messages
              v-if = "isMessages"
              :contactObject = "contactObject"
              :chatConnected = "chatConnected"
              ref="Messages"
              />
            <Contacts
              v-if = "isContacts"
              :makeCall = "makeHistoryCall"
              :makeVideoCall = "makeHistoryVideoCall"
              :extension = "extension"
              :selectNumber = "selectNumber"
              :contacts = "contacts"
              :sortedContacts = "sortedContacts"
              :speeddials = "speeddials"
              :sortedSpeeddials = "sortedSpeeddials"
              :sendMessage = "sendMessage"
              :updateContact = "updateContact"
              :newContact = "newContact"
              :removeContact = "removeContact"
              />
            <Recents
              ref="recents"
              v-if = "isRecents"
              :history = "history"
              :makeHistoryCall = "makeHistoryCall"
              :makeHistoryVideoCall = "makeHistoryVideoCall"
              :removeHistoryCall = "removeHistoryCall"
              :removeHistory = "removeHistory"
              :ampm = "ampm"
              :selectNumber = "selectNumber"
              :sendMessage = "sendMessage"
              />
            <Settings
              v-if = "isSettings"
              :name = "caller_id_name"
              :extension = "extension"
              :windowWidth = "windowWidth"
              :onGoingCalls = "onGoingCalls"
              :vertoHandle = "vertoHandle"
              :fractelfone = "fractelfone"
              :io = "io"
              :DNDchange = "DNDchange"
              />
          </div>
        </div>
        <div class="row" style="padding: 0 0; font-size: 1.5rem; width: 100%; bottom: 0; position: fixed; height: 58px; background-color: #E6E6E6;">
          <div class="col-2 offset-1 bottom-nav-item" @click="setMessages">
            <i class="mdi mdi-message active" aria-hidden="true" v-if="isMessages"></i>
            <i class="mdi mdi-message" aria-hidden="true" v-else></i>
            <b-badge pill variant="primary" style="font-size: 45%; position: absolute;" v-if="unread > 0">
              <span v-if="unread > 99">99+</span>
              <span v-else>{{ unread }}</span>
            </b-badge>
          </div>
          <div class="col-2 bottom-nav-item" @click="setContacts">
            <i class="mdi mdi-contacts active" aria-hidden="true" v-if="isContacts"></i>
            <i class="mdi mdi-contacts" aria-hidden="true" v-else></i>
          </div>
          <div class="col-2 bottom-nav-item" @click="setRecents">
            <i class="mdi mdi-history active" aria-hidden="true" v-if="isRecents"></i>
            <i class="mdi mdi-history" aria-hidden="true" v-else></i>
            <b-badge pill variant="danger" style="font-size: 45%; position: absolute;" v-if="missed > 0">
              <span v-if="missed > 99">99+</span>
              <span v-else>{{ missed }}</span>
            </b-badge>
          </div>
          <div class="col-2 bottom-nav-item" @click="setSettings">
            <i class="mdi mdi-cog active" aria-hidden="true" v-if="isSettings"></i>
            <i class="mdi mdi-cog" aria-hidden="true" v-else></i>
          </div>
          <div class="col-2 bottom-nav-item" @click="setVoicemail">
            <i class="mdi mdi-voicemail" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row parking-big-row-fixed main-container" v-if="loggedIn">
      <div style="width: 100%; padding: 0 15px;">
        <div class="row">
          <div class="row" style="padding: 2px 0 0 0; margin-bottom: 2rem; margin-left: 0.1rem; width: 100%;">
            <div class="col-4" style="padding-top: 1px;" v-for="i in no_of_lines" :key="`selectLine${i}`" @click="tabChange(i)">
              <span class="nav-link active" v-if="tabIndex === (i - 1)">
                <span v-if="calls[`line${i}`].onCall && calls[`line${i}`].hold"><i class="mdi mdi-pause" aria-hidden="true"></i>&nbsp;</span>
                <span v-if="calls[`line${i}`].onCall && !calls[`line${i}`].hold"><b-spinner type="grow" small></b-spinner></span>
                {{ $t('parking.line') }}{{i}}<br />
                <span v-if="calls[`line${i}`].onCall">{{ calls[`line${i}`].currentCall.params.remote_caller_id_number === `DEVCONF${username}` ? $t('parking.conferenceCall') : (calls[`line${i}`].currentCall.params.remote_caller_id_number === '9999999' ? 'Voicemail' : calls[`line${i}`].currentCall.params.remote_caller_id_number.substring(0, 10)) }}</span>
                <span style="color: rgb(214, 214, 214);" v-else>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('parking.idle') }}&nbsp;&nbsp;&nbsp;</span>
              </span>
              <span class="nav-link hold" v-else-if="calls[`line${i}`].onCall && calls[`line${i}`].hold">
                <i class="mdi mdi-pause" aria-hidden="true"></i>&nbsp;{{ $t('parking.line') }}{{i}}<br />
                <span v-if="calls[`line${i}`].onCall">{{ calls[`line${i}`].currentCall.params.remote_caller_id_number === `DEVCONF${username}` ? $t('parking.conferenceCall') : (calls[`line${i}`].currentCall.params.remote_caller_id_number === '9999999' ? 'Voicemail' : calls[`line${i}`].currentCall.params.remote_caller_id_number.substring(0, 10)) }}</span>
                <span style="color: rgb(214, 214, 214);" v-else>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('parking.idle') }}&nbsp;&nbsp;&nbsp;</span>
              </span>
              <span class="nav-link oncall" v-else-if="calls[`line${i}`].onCall && !calls[`line${i}`].hold">
                <b-spinner type="grow" small></b-spinner>&nbsp;{{ $t('parking.line') }}{{i}}<br />
                <span v-if="calls[`line${i}`].onCall">{{ calls[`line${i}`].currentCall.params.remote_caller_id_number === `DEVCONF${username}` ? $t('parking.conferenceCall') : (calls[`line${i}`].currentCall.params.remote_caller_id_number === '9999999' ? 'Voicemail' : calls[`line${i}`].currentCall.params.remote_caller_id_number.substring(0, 10)) }}</span>
                <span style="color: rgb(214, 214, 214);" v-else>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('parking.idle') }}&nbsp;&nbsp;&nbsp;</span>
              </span>
              <span class="nav-link" v-else-if="tabIndex !== (i - 1) && !calls[`line${i}`].onCall">
                {{ $t('parking.line') }}{{i}}<br />
                <span v-if="calls[`line${i}`].onCall">{{ calls[`line${i}`].currentCall.params.remote_caller_id_number === `DEVCONF${username}` ? $t('parking.conferenceCall') : (calls[`line${i}`].currentCall.params.remote_caller_id_number === '9999999' ? 'Voicemail' : calls[`line${i}`].currentCall.params.remote_caller_id_number.substring(0, 10)) }}</span>
                <span style="color: rgb(214, 214, 214);" v-else>&nbsp;&nbsp;&nbsp;&nbsp;{{ $t('parking.idle') }}&nbsp;&nbsp;&nbsp;</span>
              </span>
            </div>
          </div>
          <div class="col-12" style="padding: 0;">
            <img v-if="$whitelabel.showLogo()" :src="require('../../../assets/fractel.png')" style="position: absolute; left: 5px; top: 5px; z-index: 999; cursor: pointer;" width="auto" height="24px" @click="showFractelfoneInfo">
            <span style="position: absolute; left: 5px; top: 30px; z-index: 999; background-color: red; color: white; padding-left: 2px; padding-right: 2px; font-size: 10px;" width="auto" height="24px" v-if="DND === 'On'"><i class="mdi mdi-minus-circle" aria-hidden="true"></i>&nbsp;DND</span>
            <b-card class="phone-card" style="border: 0;" v-for="i in no_of_lines" :key="`line${i}`" v-show="tabIndex === (i - 1)">
              <b-card-text>
                <Phone :ref="`line${i}`"
                  :sequence = "i"
                  :vertoHandle = "vertoHandle"
                  :username = "username"
                  :caller_id = "caller_id"
                  :caller_id_name = "caller_id_name"
                  :call = "calls[`line${i}`]"
                  :attendedTransferCall = "attendedTransferCall"
                  :completeAttendedTransferCall = "completeAttendedTransferCall"
                  :mergeAttendedTransferCall = "mergeAttendedTransferCall"
                  :ringInterval.sync = "ringInterval"
                  :ringNotification.sync = "ringNotification"
                  :activeCalls = "activeCalls"
                  :changeOnGoingCalls = "changeOnGoingCalls"
                  :mergeCalls = "mergeCalls"
                  :windowWidth = "windowWidth"
                  :audioOnly = "audioOnly"
                  />
              </b-card-text>
            </b-card>
          </div>
        </div>
        <div class="row" style="padding: 0 0; font-size: 1.5rem; width: 100%; bottom: 0; position: fixed; height: 58px; background-color: #E6E6E6;">
          <div class="col-2 offset-1 bottom-nav-item" @click="setMessages">
            <i class="mdi mdi-message active" aria-hidden="true" v-if="isMessages"></i>
            <i class="mdi mdi-message" aria-hidden="true" v-else></i>
            <b-badge pill variant="primary" style="font-size: 45%; position: absolute;" v-if="unread > 0">
              <span v-if="unread > 99">99+</span>
              <span v-else>{{ unread }}</span>
            </b-badge>
          </div>
          <div class="col-2 bottom-nav-item" @click="setContacts">
            <i class="mdi mdi-contacts active" aria-hidden="true" v-if="isContacts"></i>
            <i class="mdi mdi-contacts" aria-hidden="true" v-else></i>
          </div>
          <div class="col-2 bottom-nav-item" @click="setRecents">
            <i class="mdi mdi-history active" aria-hidden="true" v-if="isRecents"></i>
            <i class="mdi mdi-history" aria-hidden="true" v-else></i>
            <b-badge pill variant="danger" style="font-size: 45%; position: absolute;" v-if="missed > 0">
              <span v-if="missed > 99">99+</span>
              <span v-else>{{ missed }}</span>
            </b-badge>
          </div>
          <div class="col-2 bottom-nav-item" @click="setSettings">
            <i class="mdi mdi-cog active" aria-hidden="true" v-if="isSettings"></i>
            <i class="mdi mdi-cog" aria-hidden="true" v-else></i>
          </div>
          <div class="col-2 bottom-nav-item" @click="setVoicemail">
            <i class="mdi mdi-voicemail" aria-hidden="true"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="screen-center" v-if="!loggedIn">
      <img v-if="$whitelabel.showLogo()" :src="require('../../../assets/sqrql_logo.png')" width="80px" height="80px">
      <h4 style="width: 160px;">{{ connectionMessage }}</h4>
    </div>
    <div style="width: 0; height: 0;">
      <audio id="ringer">
        <source :src="require('../../../assets/sounds/bell_ring2.wav')" type="audio/wav">
      </audio>
      <audio id="chime">
        <source :src="require('../../../assets/sounds/chime.mp3')" type="audio/mpeg">
      </audio>
    </div>
    <b-modal
      ref="fractelInfo"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        <img v-if="$whitelabel.showLogo()" :src="require('../../../assets/fractel-logo-full.png')" style="background-color: grey; padding: 5px;" width="auto" height="84px">
        <br /><br /><br />
        {{ $whitelabel.getAppName() }} <br />
        {{ $t('parking.version') }} 1.0.0
        <br /><br />
        <a v-if="$whitelabel.showUserGuide()" :href="$whitelabel.getUserGuideUrl()" style="color: #009AB1;" target="_blank">{{ $t('parking.userGuide', { appName: $whitelabel.getAppName() }) }}</a>
        <br />
        <span v-if="$whitelabel.showBranding()">&copy;{{currentYear}}. {{ $t('parking.rights') }}&nbsp;<a href="http://fractel.com" style="color: #009AB1;" target="_blank">FracTEL, LLC </a></span>
      </div>
    </b-modal>
    <b-modal
      ref="ringerPermission"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        <span v-if="ringerLoading"><b-spinner variant="teal" label="Spinning"></b-spinner></span>
        <span v-else>{{ $t('parking.allowSoundNotification') }}</span>
        <b-button class="mt-2" variant="outline-secondary" block :disabled="ringerLoading" @click="dontPlayRinger">{{ $t('parking.cancel') }}</b-button>
        <b-button class="mt-2 primary-button" block :disabled="ringerLoading" @click="playRinger">{{ $t('parking.allow') }}</b-button>
      </div>
    </b-modal>
    <b-modal
      style=""
      ref="devicePermissionError"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      hide-backdrop
      >
      <div style="text-align: center;">
        <span>{{ devicePermissionErrorText }}</span>
        <b-button class="mt-2" variant="outline-secondary" block @click="hideDevicePermissionError" v-if="audioOnly">Hide</b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import Moment from 'moment-timezone'
import jQuery from 'jquery'
// import $ from 'jquery-json'
import FSRTC from 'FSRTC'
import jsonRpcClient from 'jsonrpcclient'
import verto from 'verto'
import SocketIO from 'socket.io-client'

import Phone from '../phone/Phone'
import Messages from './components/Messages'
import Contacts from './components/Contacts'
import Recents from './components/Recents'
import Settings from './components/Settings'

export default {
  name: 'Parking',
  components: {
    Phone,
    Messages,
    Contacts,
    Recents,
    Settings
  },
  mounted: async function () {
    var self = this

    // Resize the window
    if (self.windowWidth < 800) {
      window.resizeTo(420, 604)
    }

    jQuery.verto.init({}, self.bootstrap)

    // Messaging
    const device = localStorage.getItem('device')
    self.io = SocketIO(process.env.CHAT_SERVER, {
      query: {
        token: localStorage.getItem('fonestorm-token'),
        device,
        id: self.unique_id
      }
    })
    self.io.on('connect', () => {
      self.chatConnected = true

      // Ringer Permission
      if (!self.ringerPermissionAsked) {
        self.$refs['ringerPermission'].show()
        self.ringerPermissionAsked = true
      }
      console.log('Connected')
    })
    self.io.on('disconnect', () => {
      self.chatConnected = false
      console.log('Disconnected')
      /*
      setTimeout(() => {
        self.io.reconnect()
      }, 5000)
      */
    })
    self.io.on('message', async (data) => {

      let messages = {}
      let sessions = []
      if (localStorage.getItem(`message-sessions-${device}`)) {
        sessions = localStorage.getItem(`message-sessions-${device}`).split(',')
      }
      if (localStorage.getItem(`messages-${device}`)) {
        messages = JSON.parse(localStorage.getItem(`messages-${device}`))
      }

      if (data.to.split(',').length > 1) {
        data.to.split(',').forEach((to) => {
          if (self.caller_id !== to) {
            data.from = data.from + ',' + to;
          }
        });

        data.from = data.from.split(',').sort().join(':');
        data.to = self.caller_id;
      }

      if (!messages[data.from]) {
        messages[data.from] = []
      }
      if (sessions.indexOf(data.from) < 0) {
        sessions.push(data.from)
      }

      var alreadyPresent = false
      messages[data.from].forEach((message) => {
        if (message.id === data.id) {
          alreadyPresent = true
        }
      })

      var read = false
      if (self.isMessages && self.$refs['Messages'] && data.from === self.$refs['Messages'].selectedSession) {
        read = true
      } else {
        if (self.DND !== 'On') {
          var notification = new Notification('New message', {
            body: `From: ${data.from.split(':').toString()}`,
            icon: require('../../../assets/sqrql_logo.png'),
            requireInteraction: false
          })
          document.getElementById('chime').play()

          notification.onclick = function () { window.focus() }

          setTimeout(() => {
            notification.close()
          }, 5000)
        }
      }

      // Unread messages counter
      if (!self.isMessages) {
        self.unread = self.unread + 1
      }

      if (!alreadyPresent) {
        if (data.media) {
          const fonestormFile = await axios.post(`${process.env.FONESTORM_API}/documents/verto`, { file_url: data.media }, { headers: { token: localStorage.getItem('fonestorm-token') } })
          data.media = `${process.env.FONESTORM_API}${fonestormFile.data.document.url}`
          // data.media = fonestormFile.data.document.cloud_url
        }

        messages[data.from].push({
          id: data.id,
          from: data.from,
          to: data.to,
          direction: 'IN',
          msg: data.message,
          media: data.media,
          time: data.time,
          read
        })

        localStorage.setItem(`message-sessions-${device}`, sessions)
        localStorage.setItem(`messages-${device}`, JSON.stringify(messages))
      }

      if (self.isMessages) {
        self.$refs['Messages'].refreshChat()
      }
    })

    // Notification Permission
    // Notification doesn't work with apple
    if (typeof Notification !== 'undefined' && (Notification.permission !== 'granted' || Notification.permission !== 'denied')) {
      Notification.requestPermission()
    }

    if (!localStorage.getItem('timeFormat')) {
      localStorage.setItem('timeFormat', true)
    } else {
      self.ampm = localStorage.getItem('timeFormat') === 'true'
    }

    // Load Call History
    if (localStorage.getItem(`vertoHistory-${self.username}`) && JSON.parse(localStorage.getItem(`vertoHistory-${self.username}`)).length > 0) {
      // If call history is present, fetch only remaining records
      self.history = JSON.parse(localStorage.getItem(`vertoHistory-${self.username}`))

      // Find last call's timestamp
      let lastCall = self.history[self.history.length - 1]
      let lastCallTimeStamp = lastCall.timeStamp
      let month = (self.months.indexOf(lastCallTimeStamp.split(' ')[0]) + 1).toString().padStart(2, '0')
      let date = lastCallTimeStamp.split(' ')[1].split(',')[0].padStart(2, '0')
      let year = lastCallTimeStamp.split(' ')[2]
      let time = lastCallTimeStamp.split(' ')[3]
      lastCallTimeStamp = `${year}-${month}-${date} ${time}`

      // Guess Timezone of the client and modify timestamp accordingly
      if (Moment.tz.guess() !== 'America/New_York') {
        lastCallTimeStamp = Moment.tz(lastCallTimeStamp, Moment.tz.guess()).tz('America/New_York').format('YYYY-MM-DD HH:mm:ss')
      }

      // Call CDR History API
      try {
        const response = await axios.get(`${process.env.CDR_API}/history/calls?device=${self.username}&no_of_calls=50&start_date=${lastCallTimeStamp}`, { headers: { token: localStorage.getItem('fonestorm-token') } })
        response.data.cdrs.reverse().forEach((cdr) => {
          // Adding CDR history to Recents page
          let destination = cdr.dst;

          cdr.billsec = parseInt(cdr.billsec)
          let totalSeconds = cdr.billsec
          let duration = '00:00:00'
          if (cdr.billsec > 0) {
            let hours = Math.floor(totalSeconds / 3600)
            totalSeconds = totalSeconds % 3600
            let minutes = Math.floor(totalSeconds / 60)
            let seconds = totalSeconds % 60

            duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
          }

          if (cdr.dcontext === 'inbound') {
            destination = cdr.src;
          }
          self.history.push({
            number: destination === `DEVCONF${self.username}` ? self.$t('parking.conferenceCall') : (destination === '9999999' ? 'Voicemail' : destination),
            direction: `${cdr.dcontext.charAt(0).toUpperCase()}${cdr.dcontext.slice(1)}`,
            hangupCause: cdr.disposition === 'ANSWERED' ? 'NORMAL_CLEARING' : cdr.disposition,
            answered: cdr.billsec > 0 || cdr.disposition === 'ANSWERED',
            duration,
            timeStamp: Moment.tz(`${cdr.calldate.split('T')[0]} ${cdr.calldate.split('T')[1].split('.')[0]}`, 'America/New_York').tz(Moment.tz.guess()).format('MMM D, YYYY HH:mm:ss')
          })

          if (cdr.billsec === 0 && cdr.disposition !== 'ANSWERED') {
            self.missed = self.missed + 1
          } else {
            self.missed = 0
          }
        })
      } catch (error) {
        if (error.response.status === 401) {
          self.$router.push({ name: 'Login' })
        }
      }

      // Keep only 50 records
      if (self.history.length > 50) {
        do {
          self.history.shift()
        } while (self.history.length > 50)
      }
      localStorage.setItem(`vertoHistory-${self.username}`, JSON.stringify(self.history))
    } else {
      // If call history is empty, fetch last 50 records
      self.history = []

      // Load History
      try {
        const response = await axios.get(`${process.env.CDR_API}/history/calls?device=${self.username}&no_of_calls=50`, { headers: { token: localStorage.getItem('fonestorm-token') } })
        response.data.cdrs.reverse().forEach((cdr) => {
          // Adding CDR history to Recents page
          let destination = cdr.dst;

          cdr.billsec = parseInt(cdr.billsec)
          let totalSeconds = cdr.billsec
          let duration = '00:00:00'
          if (cdr.billsec > 0) {
            let hours = Math.floor(totalSeconds / 3600)
            totalSeconds = totalSeconds % 3600
            let minutes = Math.floor(totalSeconds / 60)
            let seconds = totalSeconds % 60

            duration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
          }

          if (cdr.dcontext === 'inbound') {
            destination = cdr.src;
          }
          self.history.push({
            number: destination === `DEVCONF${self.username}` ? self.$t('parking.conferenceCall') : (destination === '9999999' ? 'Voicemail' : destination),
            direction: `${cdr.dcontext.charAt(0).toUpperCase()}${cdr.dcontext.slice(1)}`,
            hangupCause: cdr.disposition === 'ANSWERED' ? 'NORMAL_CLEARING' : cdr.disposition,
            answered: cdr.billsec > 0 || cdr.disposition === 'ANSWERED',
            duration,
            timeStamp: Moment.tz(`${cdr.calldate.split('T')[0]} ${cdr.calldate.split('T')[1].split('.')[0]}`, 'America/New_York').format('MMM D, YYYY HH:mm:ss')
          })

          if (cdr.billsec === 0 && cdr.disposition !== 'ANSWERED') {
            self.missed = self.missed + 1
          } else {
            self.missed = 0
          }
        })
      } catch (error) {
        if (error.response.status === 401) {
          self.$router.push({ name: 'Login' })
        }
      }
      localStorage.setItem(`vertoHistory-${self.username}`, JSON.stringify(self.history))
    }

    window.addEventListener('keydown', evt => {
      if (!self.isRecentsSearch && !self.isContactsSearch && !self.isMessagesSearch) {
        if (evt.key >= '0' && evt.key <= '9') {
          self.calls[`line${self.tabIndex + 1}`].transferInitiated ? self.$refs[`line${self.tabIndex + 1}`][0].transferDigit(evt.key) : (self.calls[`line${self.tabIndex + 1}`].dtmf ? self.$refs[`line${self.tabIndex + 1}`][0].dtmfDigit(evt.key) : self.$refs[`line${self.tabIndex + 1}`][0].digit(evt.key))
        } else if (evt.key === '*' || evt.key === '#' || evt.key === '+') {
          self.calls[`line${self.tabIndex + 1}`].transferInitiated ? self.$refs[`line${self.tabIndex + 1}`][0].transferDigit(evt.key) : (self.calls[`line${self.tabIndex + 1}`].dtmf ? self.$refs[`line${self.tabIndex + 1}`][0].dtmfDigit(evt.key) : self.$refs[`line${self.tabIndex + 1}`][0].digit(evt.key))
        } else if (evt.key === 'Backspace') {
          self.calls[`line${self.tabIndex + 1}`].transferInitiated ? self.$refs[`line${self.tabIndex + 1}`][0].transferBackspace() : (self.calls[`line${self.tabIndex + 1}`].dtmf ? self.$refs[`line${self.tabIndex + 1}`][0].dtmfBackspace() : self.$refs[`line${self.tabIndex + 1}`][0].backspace())
        } else if (evt.key === 'Enter') {
          if (self.calls[`line${self.tabIndex + 1}`].number) {
            self.$refs[`line${self.tabIndex + 1}`][0].makeCall()
          }
        }
      } else if (self.isMessagesSearch) {
        if (evt.key === 'Enter') {
          if (self.$refs['Messages'].selectedSession >= 0) {
            self.$refs['Messages'].send()
          } else {
            self.$refs['Messages'].addChat()
          }
        }
      }
    })

    try {
      var response = await axios.get(`${process.env.FONESTORM_API}/speeddials`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.speeddials = []
      response.data.speedDials.forEach((speeddial) => {
        if (speeddial.speed_dial !== self.extension) {
          self.speeddials.push(speeddial)
        }
      })
      self.sortedSpeeddials = self.speeddials.slice(0).sort((a, b) => parseInt(a.speed_dial) < parseInt(b.speed_dial) ? -1 : 1 )

      response = await axios.get(`${process.env.FONESTORM_API}/contacts`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.contacts = response.data.contacts
      self.sortedContacts = self.contacts.slice(0).sort((a, b) => a.full_name < b.full_name ? -1 : 1 )
      self.sortedContacts.forEach((contact) => {
        self.contactObject[contact.phone] = contact.full_name
      })
    } catch (error) {
      if (error.response.status === 401) {
        self.$router.push({ name: 'Login' })
      }
    }
  },
  props: {
    username: {
      type: String,
      required: true
    },
    password: {
      type: String,
      required: true
    },
    caller_id: {
      type: String,
      required: true
    },
    caller_id_name: {
      type: String,
      required: false
    },
    extension: {
      type: String,
      required: false
    },
    hostname: {
      type: String,
      required: true
    },
    websocket_url: {
      type: String,
      required: true
    },
    no_of_lines: {
      type: Number,
      default: 3
    },
    unique_id: {
      type: String
    },
    fractelfone: {
      type: String
    }
  },
  data () {
    return {
      chatConnected: false,
      verto,
      FSRTC,
      jsonRpcClient,
      loggedIn: false,
      connectionMessage: this.$t('parking.loading'),
      tabIndex: 0,
      vertoHandle: {},
      ringInterval: null,
      ringNotification: null,
      history: [],
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      isMessages: false,
      isContacts: false,
      isRecents: false,
      isSettings: false,
      isRecentsSearch: false,
      isContactsSearch: false,
      isMessagesSearch: false,
      ampm: true,
      onGoingCalls: 0,
      contacts: null,
      sortedContacts: null,
      contactObject: {},
      speeddials: null,
      sortedSpeeddials: null,
      unread: 0,
      missed: 0,
      io: null,
      ringerLoading: false,
      ringerPermissionAsked: false,
      devicePermissionErrorText: '',
      audioOnly: false,
      DND: localStorage.getItem('DND') || 'Off',
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      calls: {
        line1: {
          name: 'Line 1',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line2: {
          name: 'Line 2',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line3: {
          name: 'Line 3',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line4: {
          name: 'Line 4',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line5: {
          name: 'Line 5',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line6: {
          name: 'Line 6',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line7: {
          name: 'Line 7',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        },
        line8: {
          name: 'Line 8',
          number: '',
          transferNumber: '',
          attendedTransferInitiatorID: '',
          attendedTransferInitiator: '',
          attendedTransferInitiatorLine: '',
          dtmfNumber: '',
          incomingNumber: '',
          time: 0,
          timeFormated: '',
          interval: null,
          onCall: false,
          transferInitiated: false,
          transferInProgress: false,
          mute: false,
          hold: false,
          currentCall: null,
          mergeCallee: null,
          mergeInProgress: false,
          isVideo: false,
          camera: true,
          hangupCause: '',
          direction: '',
          callRinging: false,
          attendedTransfering: false,
          mergeRequesting: false,
          mergeNotAvailable: false,
          dtmf: false,
          contact: null
        }
      }
    }
  },
  computed: {
    currentYear () {
      var now = new Date()
      return now.getFullYear()
    }
  },
  methods: {
    attendedTransferCall (number, id, transferNumber, name) {
      var self = this
      var transferLine = null
      var transferTab = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (!self.calls[`line${i}`].currentCall) {
          transferLine = `line${i}`
          transferTab = i - 1
          break
        }
        if (id === self.calls[`line${i}`].currentCall.params.callID) {
          self.calls[`line${i}`].transferInitiated = false
        }
      }

      self.calls[transferLine].number = transferNumber
      self.calls[transferLine].attendedTransferInitiator = number
      self.calls[transferLine].attendedTransferInitiatorID = id
      self.calls[transferLine].attendedTransferInitiatorLine = name
      self.$refs[transferLine][0].makeCall()
      self.tabIndex = transferTab
      self.$refs[transferLine][0].$refs['attendedTransfer'].show()
    },
    completeAttendedTransferCall (first, second) {
      var self = this
      var firstCall = null
      var secondCall = null
      var secondCallLine = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (self.calls[`line${i}`].currentCall && first === self.calls[`line${i}`].currentCall.params.callID) {
          firstCall = self.calls[`line${i}`].currentCall
        } else if (self.calls[`line${i}`].currentCall && second === self.calls[`line${i}`].currentCall.params.callID) {
          secondCall = self.calls[`line${i}`].currentCall
          secondCallLine = `line${i}`
          self.calls[`line${i}`].transferInProgress = true
        }
      }

      firstCall.replace(secondCall.callID)
      self.$refs[secondCallLine][0].$refs['attendedTransfer'].hide()
      self.calls[secondCallLine].transferInProgress = false
    },
    mergeAttendedTransferCall (first, second) {
      var self = this
      var firstCall = null
      var secondCall = null
      var secondCallLine = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (self.calls[`line${i}`].currentCall && first === self.calls[`line${i}`].currentCall.params.callID) {
          firstCall = self.calls[`line${i}`].currentCall
        } else if (self.calls[`line${i}`].currentCall && second === self.calls[`line${i}`].currentCall.params.callID) {
          secondCall = self.calls[`line${i}`].currentCall
          secondCallLine = `line${i}`
          self.calls[`line${i}`].transferInProgress = true
        }
      }

      firstCall.transfer(`DEVCONF${self.username}`)
      setTimeout(() => {
        for (var i = 1; i <= self.no_of_lines; i++) {
          if (!self.calls[`line${i}`].currentCall) {
            self.calls[`line${i}`].number = `DEVCONF${self.username}`
            self.$refs[`line${i}`][0].makeCall()
            break
          }
        }
      }, 3000)

      setTimeout (() => {
        self.$refs[secondCallLine][0].$refs['attendedTransfer'].hide()
        self.calls[secondCallLine].transferInProgress = false
        secondCall.transfer(`DEVCONF${self.username}`)
      }, 6000)
    },
    activeCalls () {
      var self = this
      var activeCalls = 0
      var activeCall = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (self.calls[`line${i}`].onCall) {
          activeCalls = activeCalls + 1

          if (!self.calls[`line${i}`].hold && !self.calls[`line${i}`].isVideo) {
            activeCall = self.calls[`line${i}`]
          }
        }
      }

      return { activeCalls, activeCall }
    },
    mergeCalls (first, second) {
      var self = this
      var firstCall = null
      var secondCall = null
      var secondCallLine = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (self.calls[`line${i}`].currentCall && first === self.calls[`line${i}`].currentCall.params.callID) {
          firstCall = self.calls[`line${i}`].currentCall
        } else if (self.calls[`line${i}`].currentCall && second === self.calls[`line${i}`].currentCall.params.callID) {
          secondCall = self.calls[`line${i}`].currentCall
          secondCallLine = `line${i}`
          self.calls[`line${i}`].mergeInProgress = true
        }
      }

      firstCall.transfer(`DEVCONF${self.username}`)
      setTimeout (() => {
        for (var i = 1; i <= self.no_of_lines; i++) {
          if (!self.calls[`line${i}`].currentCall) {
            self.calls[`line${i}`].number = `DEVCONF${self.username}`
            self.$refs[`line${i}`][0].makeCall()
            break
          }
        }
      }, 3000)

      setTimeout (() => {
        self.$refs[secondCallLine][0].$refs['mergeRequest'].hide()
        secondCall.transfer(`DEVCONF${self.username}`)
        secondCall.mergeInProgress = false
      }, 6000)
    },
    makeHistoryCall (number) {
      var self = this

      self.isMessages = false
      self.isContacts = false
      self.isRecents = false
      self.isSettings = false
      self.isContactsSearch = false
      self.isRecentsSearch = false
      self.isMessagesSearch = false

      var line = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (!self.calls[`line${i}`].currentCall) {
          line = `line${i}`
          self.tabIndex = i - 1
          break
        }
      }

      self.calls[line].number = number
      self.tabIndex = i - 1

      setTimeout(() => {
        self.$refs[line][0].makeCall()
      }, 1000)
    },
    makeHistoryVideoCall (number) {
      var self = this

      self.isMessages = false
      self.isContacts = false
      self.isRecents = false
      self.isSettings = false
      self.isContactsSearch = false
      self.isRecentsSearch = false
      self.isMessagesSearch = false

      var line = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (!self.calls[`line${i}`].currentCall) {
          line = `line${i}`
          self.tabIndex = i - 1
          break
        }
      }

      self.calls[line].number = number
      self.tabIndex = i - 1

      setTimeout(() => {
        self.$refs[line][0].makeVideoCall()
      }, 1000)
    },
    selectNumber (number) {
      var self = this
      var line = null

      if (isNaN(number)) {
        if (number === 'Voicemail') {
          number = '9999999'
        } else {
          return number
        }
      }

      if (self.calls[`line${self.tabIndex + 1}`].onCall) {
        if (self.calls[`line${self.tabIndex + 1}`].transferInitiated) {
          self.calls[`line${self.tabIndex + 1}`].transferNumber = number
        } else {
          for (var i = 1; i <= self.no_of_lines; i++) {
            if (!self.calls[`line${i}`].currentCall) {
              line = `line${i}`
              self.tabIndex = i - 1
              break
            }
          }

          self.calls[line].number = number
          self.tabIndex = i - 1
        }
      } else {
        self.calls[`line${self.tabIndex + 1}`].number = number
      }
    },
    logout () {
      this.$router.push({ name: 'Login' })
    },
    tabChange (i) {
      this.tabIndex = i - 1
    },
    setMessages () {
      var self = this

      if (!self.isMessages && !self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth + 240, 604)
      } else if (self.isMessages && !self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth - 240, 604)
      }

      self.isMessages = !self.isMessages
      self.isContacts = false
      self.isRecents = false
      self.isSettings = false
      self.isContactsSearch = false
      self.isRecentsSearch = false
      self.isMessagesSearch = self.isMessages
      self.unread = 0
    },
    setContacts () {
      var self = this

      if (!self.isMessages && !self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth + 240, 604)
      } else if (!self.isMessages && self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth - 240, 604)
      }

      self.isMessages = false
      self.isContacts = !self.isContacts
      self.isRecents = false
      self.isSettings = false
      self.isContactsSearch = self.isContacts
      self.isRecentsSearch = false
      self.isMessagesSearch = false
    },
    setRecents () {
      var self = this

      if (!self.isMessages && !self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth + 240, 604)
      } else if (!self.isMessages && !self.isContacts && self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth - 240, 604)
      }

      self.ampm = localStorage.getItem('timeFormat') === 'true'
      self.isMessages = false
      self.isContacts = false
      self.isRecents = !self.isRecents
      self.isSettings = false
      self.isContactsSearch = false
      self.isRecentsSearch = self.isRecents
      self.isMessagesSearch = false
      self.missed = 0
    },
    setSettings () {
      var self = this

      if (!self.isMessages && !self.isContacts && !self.isRecents && !self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth + 240, 604)
      } else if (!self.isMessages && !self.isContacts && !self.isRecents && self.isSettings && self.windowWidth < 800) {
        window.resizeTo(window.innerWidth - 240, 604)
      }

      self.isMessages = false
      self.isContacts = false
      self.isRecents = false
      self.isSettings = !self.isSettings
      self.isContactsSearch = false
      self.isRecentsSearch = false
      self.isMessagesSearch = false
    },
    setVoicemail () {
      var self = this

      self.isMessages = false
      self.isContacts = false
      self.isRecents = false
      self.isSettings = false
      self.isContactsSearch = false
      self.isRecentsSearch = false
      self.isMessagesSearch = false

      var line = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (!self.calls[`line${i}`].currentCall) {
          line = `line${i}`
          self.tabIndex = i - 1
          break
        }
      }

      self.calls[line].number = '9999999'
      self.tabIndex = i - 1

      setTimeout(() => {
        self.$refs[line][0].makeCall()
      }, 1000)
    },
    removeHistoryCall (h) {
      var self = this
      var tempHistory = []
      self.history = JSON.parse(localStorage.getItem(`vertoHistory-${self.username}`))
      self.history.forEach((history) => {
        if (history.timeStamp === h.timeStamp && history.number === h.number && history.answered === h.answered && history.direction === h.direction && history.duration === h.duration && history.hangupCause === h.hangupCause) {
          // Don't add to array
        } else {
          tempHistory.push(history)
        }
      })
      self.history = tempHistory
      self.$refs.recents.performReload(self.history)
      localStorage.setItem(`vertoHistory-${self.username}`, JSON.stringify(self.history))
    },
    removeHistory () {
      var self = this
      self.history = []
      self.$refs.recents.performReload(self.history)
      localStorage.setItem(`vertoHistory-${self.username}`, JSON.stringify(self.history))
    },
    changeOnGoingCalls (add) {
      var self = this
      self.onGoingCalls = self.onGoingCalls + add
    },
    searchContact: async function (phonenumber) {
      var self = this
      var foundContact = null

      await Promise.all(self.contacts.map((contact) => {
        if (contact.phone === phonenumber.slice(phonenumber.length - 10)) {
          foundContact = contact
        }
      }))

      return foundContact
    },
    sendMessage (number) {
      var self = this

      self.setMessages()

      setTimeout (() => {
        self.$refs['Messages'].addChatExternally(number)
      }, 1000)
    },
    showFractelfoneInfo () {
      this.$refs['fractelInfo'].show()
    },
    updateContact: async function (contact, full_name, phone) {
      var self = this
      const payload = {
        first_name: full_name.split(' ')[0].trim(),
        last_name: full_name.split(full_name.split(' ')[0])[1].trim(),
        phone
      }
      await axios.put(`${process.env.FONESTORM_API}/contacts/${contact.id}`, payload, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.refreshContacts()
    },
    newContact: async function (full_name, phone) {
      var self = this
      const payload = {
        first_name: full_name.split(' ')[0].trim(),
        last_name: full_name.split(full_name.split(' ')[0])[1].trim(),
        phone
      }
      await axios.post(`${process.env.FONESTORM_API}/contacts`, payload, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.refreshContacts()
    },
    removeContact: async function (contact) {
      var self = this
      await axios.delete(`${process.env.FONESTORM_API}/contacts/${contact.id}`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.refreshContacts()
    },
    refreshContacts: async function () {
      var self = this
      const response = await axios.get(`${process.env.FONESTORM_API}/contacts`, { headers: { token: localStorage.getItem('fonestorm-token') } })
      self.contacts = response.data.contacts
      self.sortedContacts = self.contacts.slice(0).sort((a, b) => a.full_name < b.full_name ? -1 : 1 )
      self.sortedContacts.forEach((contact) => {
        self.contactObject[contact.phone] = contact.full_name
      })
    },
    dontPlayRinger () {
      var self = this
      self.$refs['ringerPermission'].hide()
    },
    hideDevicePermissionError () {
      var self = this
      self.$refs['devicePermissionError'].hide()
    },
    playRinger () {
      var self = this
      self.ringerLoading = true

      document.getElementById('ringer').volume = 0
      document.getElementById('chime').volume = 0

      document.getElementById('ringer').play()
      document.getElementById('chime').play()

      setTimeout(() => {
        document.getElementById('ringer').volume = 1.0
        document.getElementById('chime').volume = 1.0
        self.$refs['ringerPermission'].hide()
      }, 5000)
    },
    DNDchange (status) {
      var self = this
      self.DND = status
    },
    // Verto methods
    onWSLogin (verto, success) {
      var self = this
      self.loggedIn = success
      if (success) {
        self.connectionMessage = self.$t('parking.loading')
      } else {
        self.connectionMessage = self.$t('parking.connectionFailed')
      }
    },
    onWSClose (verto, success) {
      var self = this
      self.loggedIn = false
      if (!success) {
        self.connectionMessage = self.$t('parking.disconnected')
      } else {
        self.connectionMessage = self.$t('parking.connectionFailed')
      }
    },
    // onMessage (verto, dialog, msg, data) {
    onMessage () {
      // TODO: Add code here
    },
    onDialogState: async function (d) {
      var self = this
      var line = 'line1'
      var incomingLine = null

      for (var i = 1; i <= self.no_of_lines; i++) {
        if (self.calls[`line${i}`].currentCall && self.calls[`line${i}`].currentCall.callID === d.callID) {
          line = `line${i}`
        }
      }

      switch (d.state.name) {
        case 'trying':
          self.calls[line].timeFormated = 'trying...'
          break
        case 'ringing':
          for (i = 1; i <= self.no_of_lines; i++) {
            if (!self.calls[`line${i}`].currentCall) {
              incomingLine = `line${i}`
              self.tabIndex = i - 1
              break
            }
          }

          // if slots are full
          if (!incomingLine) {
            break
          }
          self.calls[incomingLine].currentCall = d
          self.calls[incomingLine].incomingNumber = `${d.params.caller_id_number} ${d.params.caller_id_name ? '(' + d.params.caller_id_name + ')' : ''}`
          self.calls[incomingLine].number = d.params.caller_id_number
          self.calls[incomingLine].direction = 'Inbound'

          if (self.DND !== 'On') {
            var contact = await self.searchContact(d.params.caller_id_number)
            if (contact) {
              self.calls[incomingLine].contact = contact
            }

            // Ring and show popup
            document.getElementById('ringer').play()
            self.ringInterval = setInterval(() => {
              document.getElementById('ringer').play()
            }, 6000)
            self.$refs[incomingLine][0].$refs['callRing'].show()
            self.ringNotification = new Notification('Incoming call', {
              body: `${d.params.caller_id_number} ${d.params.caller_id_name ? '(' + d.params.caller_id_name + ')' : ''}`,
              icon: require('../../../assets/sqrql_logo.png'),
              requireInteraction: true
            })
            self.ringNotification.onclick = function () { window.focus() }

            self.calls[incomingLine].isVideo = d.params.wantVideo
          } else {
            d.hangup()
          }
          break
        case 'answering':
          self.calls[line].timeFormated = '00:00:00'
          // HOLD other calls
          for (i = 1; i <= self.no_of_lines; i++) {
            if (self.calls[`line${i}`].currentCall && self.calls[`line${i}`].currentCall.callID !== d.callID) {
              if (!self.calls[`line${i}`].hold) {
                self.$refs[`line${i}`][0].holdCall()
              }
            } else if (self.calls[`line${i}`].currentCall && self.calls[`line${i}`].currentCall.callID === d.callID) {
              self.tabIndex = i - 1
            }
          }
          if (self.calls[line].isVideo && self.windowWidth < 800) {
            window.resizeTo(window.innerWidth + 300, 604)
          }
          break
        case 'active':
          if (self.calls[line].timeFormated === '00:00:00' || self.calls[line].timeFormated === 'trying...') {
            self.$refs[line][0].toggleTimer(true)
          }

          // HOLD other calls
          for (i = 1; i <= self.no_of_lines; i++) {
            if (self.calls[`line${i}`].currentCall && self.calls[`line${i}`].currentCall.callID !== d.callID) {
              if (!self.calls[`line${i}`].hold) {
                self.$refs[`line${i}`][0].holdCall()
              }
            }
          }
          break
        case 'hangup':
          if (self.calls[line].isVideo && self.windowWidth < 800 && window.innerWidth > 700) {
            window.resizeTo(window.innerWidth - 300, 604)
          }
          var today = new Date()
          var seconds = today.getSeconds().toString().length === 1 ? '0' + today.getSeconds() : today.getSeconds()
          var minutes = today.getMinutes().toString().length === 1 ? '0' + today.getMinutes() : today.getMinutes()
          var hours = today.getHours().toString().length === 1 ? '0' + today.getHours() : today.getHours()
          // var ampm = today.getHours() >= 12 ? 'pm' : 'am'

          self.history.push({
            number: self.calls[line].number === `DEVCONF${self.username}` ? self.$t('parking.conferenceCall') : (self.calls[line].number === '9999999' ? 'Voicemail' : self.calls[line].number),
            direction: self.calls[line].direction,
            hangupCause: d.cause,
            answered: self.calls[line].time > 0 || d.answered,
            duration: self.calls[line].timeFormated === 'trying...' ? '00:00:00' : self.calls[line].timeFormated,
            timeStamp: `${self.months[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()} ${hours}:${minutes}:${seconds}`
          })

          // Keep maximum 50 entries
          if (self.history.length > 50) {
            self.history.shift()
          }
          localStorage.setItem(`vertoHistory-${self.username}`, JSON.stringify(self.history))

          self.calls[line].hangupCause = d.cause
          self.calls[line].onCall = false
          self.onGoingCalls = self.onGoingCalls - 1

          self.calls[line].mute = false
          self.calls[line].hold = false
          self.calls[line].transferInitiated = false
          self.calls[line].isVideo = false
          self.calls[line].camera = true
          self.calls[line].contact = null
          self.$refs[line][0].toggleTimer(false)

          // Stop ringing and hide notification
          if (self.ringInterval) {
            clearInterval(self.ringInterval)
            self.ringInterval = null
          }
          if (self.ringNotification) {
            self.ringNotification.close()
            self.ringNotification = null
          }
          self.$refs[line][0].$refs['callRing'].hide()
          self.$refs[line][0].$refs['attendedTransfer'].hide()
          self.calls[line].mergeRequesting = false
          self.calls[line].mergeNotAvailable = false

          // Missed call counter
          if (self.calls[line].direction === 'Inbound' && d.hangupCause !== 'NORMAL_CLEARING' && !(self.calls[line].time > 0 || d.answered) && !self.isRecents) {
            self.missed = self.missed + 1
          }
          break
        case 'destroy':
          self.calls[line].currentCall = null
          setTimeout(() => {
            self.$refs[line][0].toggleVideoTag()
          }, 1000)
          break
      }
    },
    tag () {
      var self = this
      var line = null
      for (var i = 1; i <= self.no_of_lines; i++) {
        if (!self.calls[`line${i}`].currentCall) {
          line = i
          break
        }
      }

      // if slots are full
      if (line) {
        return `webcam${line}`
      } else {
        return 'webcam'
      }
    },
    bootstrap (status) {
      var self = this
      let connectVerto = false

      /*
      ** true - Audio and video avaiable
      ** audio - Only audio available
      ** false - None available or something went wrong
      ** null - None avaiable or something went wrong
      */
      if (status === true) {
        connectVerto = true
      } else if (status === 'audio') {
        connectVerto = true
      }

      if (connectVerto) {
        if (status === 'audio') {
          self.devicePermissionErrorText = self.$t('parking.devicePermissionError1')
          self.audioOnly = true
          self.$refs['devicePermissionError'].show()
        }

        // eslint-disable-next-line
        self.vertoHandle = new jQuery.verto({
          login: `${self.username}@${self.hostname}`,
          passwd: self.password,
          socketUrl: self.websocket_url,
          tag: self.tag,
          // ringer: 'ringer',
          // localTag: localTag,
          // ringFile: require('../../../assets/sounds/bell_ring2.wav'),
          videoParams: {},
          audioParams: {
            googAutoGainControl: false,
            googNoiseSuppression: false,
            googHighpassFilter: false
          },
          iceServers: false
        }, {
          onWSLogin: self.onWSLogin,
          onWSClose: self.onWSClose,
          onMessage: self.onMessage,
          onDialogState: self.onDialogState
        })
      } else {
        // Show error
        self.devicePermissionErrorText = self.$t('parking.devicePermissionError2', { appName: self.$whitelabel.getAppName() })
        self.$refs['devicePermissionError'].show()
      }
    }
  }
}
</script>

<style scoped>

.main-container {
  background-color: white;
  height: 100%;
  width: 100%;
}

.parking-row {
  margin: 0 auto !important;
  position: fixed;
  clear: both !important;
  text-align: center !important;
}

.parking-row-collapsed {
  margin: 0 auto !important;
  position: fixed;
  clear: both !important;
  text-align: center !important;
}

.parking-big-row {
  margin: 0 auto !important;
  clear: both !important;
  text-align: center !important;
}

.parking-big-row-fixed {
  margin: 0 auto !important;
  position: fixed;
  clear: both !important;
  text-align: center !important;
}

.phone-row {
  margin: 20px auto !important;
  clear: both !important;
  text-align: center !important;
}

.phone-card .card-body {
  padding: 0;
}

.screen-center {
  position: absolute;
  height: auto;
  width: auto;
  top: 40%;
  left: 30%;
  text-align: center;
}

.screen-big-center {
  position: absolute;
  max-width: 1080px;
  height: auto;
  top: 35%;
  left: 40%;
  margin-left: -50px;
  margin-top: -25px;
}

.nav-link:hover {
  cursor: pointer;
}

.nav-link {
  display: block;
  padding: .5rem .5rem;
  border-radius: .25rem;
  color: #000;
  font-size: 0.9rem;
}

.nav-link.active {
  background-color: #009AB1 !important;
  color: #fff;
}

.nav-link.hold {
  background-color: #d6d610;
  color: #fff;
}

.nav-link.oncall {
  background-color: green;
  color: #fff;
}

fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.bottom-nav-item {
  padding: 10px;
}

.bottom-nav-item:active {
  background-color: rgba(0, 123, 255, 0.2);
}

.bottom-nav-item:hover {
  cursor: pointer;
}

.bottom-nav-item .active {
  color: #009AB1;
}

.primary-button {
  background-color: #009AB1 !important;
  border-color: #009AB1 !important;
}
</style>
